module.exports = __webpack_public_path__ + "assets/images/25B-route-sheet.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/25B-route-sheet.png
// module id = 1290
// module chunks = 1